import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "calendar-workouts" }
const _hoisted_2 = { class: "desktop-display" }
const _hoisted_3 = {
  key: 0,
  class: "workouts-display"
}
const _hoisted_4 = {
  key: 1,
  class: "donut-display"
}
const _hoisted_5 = { class: "mobile-display" }
const _hoisted_6 = {
  key: 0,
  class: "donut-display"
}

import { computed, toRefs } from 'vue'

  import CalendarWorkout from '@/components/Dashboard/UserCalendar/CalendarWorkout.vue'
  import CalendarWorkoutsChart from '@/components/Dashboard/UserCalendar/CalendarWorkoutsChart.vue'
  import { ISport } from '@/types/sports'
  import { IWorkout } from '@/types/workouts'
  import { getSportColor, getSportLabel, sportIdColors } from '@/utils/sports'
  import { getDonutDatasets } from '@/utils/workouts'

  interface Props {
    workouts: IWorkout[]
    sports: ISport[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    workouts: null,
    sports: null
  },
  setup(__props: any) {

const props = __props as {
    workouts: IWorkout[]
    sports: ISport[]
  }

  

  const { workouts, sports } = toRefs(props)
  const chartDatasets = computed(() => getDonutDatasets(props.workouts))
  const colors = computed(() => sportIdColors(props.sports))
  const displayedWorkoutCount = 6

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(workouts).length <= displayedWorkoutCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workouts).slice(0, displayedWorkoutCount), (workout, index) => {
              return (_openBlock(), _createBlock(CalendarWorkout, {
                key: index,
                workout: workout,
                sportLabel: _unref(getSportLabel)(workout, _unref(sports)),
                sportColor: _unref(getSportColor)(workout, _unref(sports))
              }, null, 8, ["workout", "sportLabel", "sportColor"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(CalendarWorkoutsChart, {
              workouts: _unref(workouts),
              sports: _unref(sports),
              datasets: _unref(chartDatasets),
              colors: _unref(colors)
            }, null, 8, ["workouts", "sports", "datasets", "colors"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(workouts).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(CalendarWorkoutsChart, {
              workouts: _unref(workouts),
              sports: _unref(sports),
              datasets: _unref(chartDatasets),
              colors: _unref(colors)
            }, null, 8, ["workouts", "sports", "datasets", "colors"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})